import { useEffect } from 'react';
import {
  Sparkles, Palette, Zap, Shield, Heart, Star, Compass, Layers, Target, Globe,
  Coffee, Utensils, Scissors, Dumbbell, Stethoscope, Briefcase, Home, Wrench, Camera,
  BookOpen, GraduationCap, Leaf, Paintbrush, Music, Car, Plane, Gift, ShoppingBag, Users,
  Clock, MapPin, Phone, Mail, CheckCircle, TrendingUp, Award, Lightbulb, Gem, Sun, Umbrella,
} from 'lucide-react';

// Brand Kit font names are plain strings (e.g. "Playfair Display") -- none of
// them are guaranteed loaded on the page, since the app itself only loads
// its own Fraunces/IBM Plex fonts. Templates render arbitrary client fonts,
// so each one needs to be fetched from Google Fonts at render time.
export const useGoogleFont = (fontName) => {
  useEffect(() => {
    if (!fontName) return;
    const id = `gfont-${fontName.replace(/\s+/g, '-')}`;
    if (document.getElementById(id)) return;
    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(fontName)}:wght@400;500;600;700&display=swap`;
    document.head.appendChild(link);
  }, [fontName]);
};

// Curated ~40-icon vocabulary matching backend/server.py's ICON_HINT_VOCABULARY --
// a fixed 10-icon set shared by every business regardless of industry was one of
// the concrete reasons every generated site felt visually identical.
const ICON_MAP = {
  sparkles: Sparkles, palette: Palette, zap: Zap, shield: Shield, heart: Heart,
  star: Star, compass: Compass, layers: Layers, target: Target, globe: Globe,
  coffee: Coffee, utensils: Utensils, scissors: Scissors, dumbbell: Dumbbell,
  stethoscope: Stethoscope, briefcase: Briefcase, home: Home, wrench: Wrench, camera: Camera,
  bookopen: BookOpen, graduationcap: GraduationCap, leaf: Leaf, paintbrush: Paintbrush,
  music: Music, car: Car, plane: Plane, gift: Gift, shoppingbag: ShoppingBag, users: Users,
  clock: Clock, mappin: MapPin, phone: Phone, mail: Mail, checkcircle: CheckCircle,
  trendingup: TrendingUp, award: Award, lightbulb: Lightbulb, gem: Gem, sun: Sun, umbrella: Umbrella,
};

export const iconFor = (hint) => ICON_MAP[(hint || '').toLowerCase()] || Sparkles;
